import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Select,
} from "reactstrap";
import { toast } from "react-toastify";
import MediaQuery from "react-responsive";
import Swal from "sweetalert2";

import {
  DataTable,
  TableRowField,
  MainLoader,
  ExportCSV,
} from "../../../../components";
import { selectUserRole } from "../../../../store/user/selector";
import { roles, layout } from "../../../../common/constants";
import { formatHelper } from "../../../../common/helpers";

import {
  getQuotations,
  deleteQuotation,
  resetQuotations,
} from "../../../../store/quotation/actions";
import { toBlankDiscount } from "../../../../common/helpers/format";
import { getQuotations as allQuotationsExport } from "../../../../service/quotation";
import { exportExcel } from "./excel";

class QuotationList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      filter: "",
      selectedStore: null,
      loadingExport: false,
    };
    this.handleObtainQuotationsExport =
      this.handleObtainQuotationsExport.bind(this);

    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
    this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this.performGetQuotations(true);
  }
  componentWillUnmount() {
    this.props.resetQuotations();
  }
  componentDidUpdate(prevProps) {
    this.checkQuotationDelete(prevProps);
  }

  performGetQuotations(reset = false) {
    const { page, filter, selectedStore } = this.state;
    const store = selectedStore
      ? selectedStore.value == 0
        ? null
        : selectedStore.value
      : selectedStore;
    this.props.getQuotations({ page, filter, reset, store });
  }
  performDeleteQuotation(id) {
    Swal({
      title: "Eliminar Cotización",
      text: "¿Estás seguro que deseas eliminar la cotización?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.props.deleteQuotation(id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }
  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetQuotations();
  }
  async filterQuotations() {
    await this.setState({ page: 1 });
    this.performGetQuotations();
  }
  async handleInputFilterChange(e) {
    if (e.key === "Enter") {
      this.filterQuotations();
    }
  }
  async checkQuotationDelete(prevProps) {
    if (
      prevProps.deletedQuotation == null &&
      this.props.deletedQuotation != null
    ) {
      toast.success("Cotización eliminada satisfactoriamente");
      await this.setState({ page: 1 });
      this.performGetQuotations();
    } else if (
      prevProps.deleteError == null &&
      this.props.deleteError != null
    ) {
      toast.error(this.props.deleteError);
    }
  }

  optionsFormatterColumn(cell, row) {
    if (this.props.role == roles.SUPER_ADMIN) {
      return (
        <UncontrolledButtonDropdown>
          <DropdownToggle size="sm" color="primary">
            <i className="fa fa-bars"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/quotations/${row.id}/detail`
                )
              }
            >
              <i className="fa fa-eye mr-1"></i> Detalle
            </DropdownItem>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/quotations/${row.id}/edit`
                )
              }
            >
              <i className="fa fa-edit mr-1"></i> Editar
            </DropdownItem>
            <DropdownItem
              disabled={this.props.deleteLoading}
              onClick={() => this.performDeleteQuotation(row.id)}
            >
              <i className="fa fa-trash mr-1"></i> Eliminar
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      );
    } else {
      return (
        <Button
          type="button"
          color="primary"
          size="sm"
          onClick={() =>
            this.props.history.push(
              `/administration/quotations/${row.id}/detail`
            )
          }
        >
          <i className="fa fa-eye"></i>
        </Button>
      );
    }
  }
  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.quotations}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  handleObtainQuotationsExport() {
    const store =
      this.state.selectedStore == null || 0
        ? null
        : this.state.selectedStore.value;
    this.setState({
      loadingExport: true,
    });
    allQuotationsExport(0, "", store)
      .then((response) => {
        exportExcel(response.data.data);
      })
      .finally(() => {
        this.setState({
          loadingExport: false,
        });
      });
  }

  render() {
    const columnOption = {
      dataField: "",
      text: "",
      formatter: this.optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };

    const columnsXS = [
      {
        dataField: "xs",
        text: "Cotizaciones",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Código:" value={row.code} />
              <TableRowField
                label="Tienda:"
                value={row.Store.name}
              ></TableRowField>
              <TableRowField
                label="Precio Total (S/):"
                value={formatHelper.toMoney(row.totalPrice)}
              />
              <TableRowField
                label="Descuento:"
                value={toBlankDiscount(row.discount)}
              />
              <TableRowField
                label="Precio Total Descontado (S/):"
                value={formatHelper.toMoney(row.totalPriceDiscounted)}
              />
              <TableRowField
                label="Cliente:"
                value={`${row.Customer.name} ${row.Customer.lastname}`}
              />
              <TableRowField
                label="Fecha de Emisión:"
                value={formatHelper.toDateDDMMYYY(row.created_at)}
              />
              <TableRowField
                label="Fecha Expiración:"
                value={formatHelper.toDateDDMMYYY(row.expirationDate)}
              />
            </div>
          );
        },
      },
      columnOption,
    ];

    const columnsSM = [
      {
        dataField: "xs",
        text: "Cotización",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Código:" value={row.code} />
              <TableRowField label="Tienda:" value={row.Store.name} />
              <TableRowField
                label="Precio Total (S/):"
                value={formatHelper.toMoney(row.totalPrice)}
              />
              <TableRowField
                label="Descuento:"
                value={toBlankDiscount(row.discount)}
              />
              <TableRowField
                label="Precio Total Descontado (S/):"
                value={formatHelper.toMoney(row.totalPriceDiscounted)}
              />
            </div>
          );
        },
      },
      {
        dataField: "client",
        text: "Cliente",
        formatter: (cell, row) => {
          return <span>{`${row.Customer.name} ${row.Customer.lastname}`}</span>;
        },
      },
      {
        dataField: "created_at",
        text: "Fecha de Emisión",
        formatter: (cell) => {
          return <span>{formatHelper.toDateDDMMYYY(cell)}</span>;
        },
      },
      {
        dataField: "expirationDate",
        text: "Fecha Expiración",
        formatter: (cell) => {
          return <span>{formatHelper.toDateDDMMYYY(cell)}</span>;
        },
      },
      columnOption,
    ];
    const columns = [
      {
        dataField: "code",
        text: "Código",
        formatter: (cell) => {
          return <span>{cell}</span>;
        },
      },
      {
        dataField: "Store.name",
        text: "Tienda",
        formatter: (cell) => {
          return <span>{cell}</span>;
        },
      },
      {
        dataField: "totalPrice",
        text: "Precio Total (S/)",
        formatter: (cell) => {
          return <span>{formatHelper.toMoney(cell)}</span>;
        },
      },
      {
        dataField: "discount",
        text: "Descuento",
        formatter: (cell, row) => {
          return <span>{toBlankDiscount(row.discount)}</span>;
        },
      },
      {
        dataField: "totalPriceDiscounted",
        text: "Precio Total Descontado (S/)",
        formatter: (cell) => {
          return <span>{formatHelper.toMoney(cell)}</span>;
        },
      },
      {
        dataField: "client",
        text: "Cliente",
        formatter: (cell, row) => {
          return <span>{`${row.Customer.name} ${row.Customer.lastname}`}</span>;
        },
      },
      {
        dataField: "created_at",
        text: "Fecha de Emisión",
        formatter: (cell) => {
          return <span>{formatHelper.toDateDDMMYYY(cell)}</span>;
        },
      },
      {
        dataField: "expirationDate",
        text: "Fecha Expiración",
        formatter: (cell) => {
          return <span>{formatHelper.toDateDDMMYYY(cell)}</span>;
        },
      },
      columnOption,
    ];
    if (this.props.loading) {
      return <MainLoader />;
    }
    return (
      <div className="animated">
        <Card>
          <CardHeader>
            <i className="icon-layers"></i>Cotizaciones
          </CardHeader>
          <CardBody>
            <MediaQuery minDeviceWidth={600}>
              {(matches) => {
                if (matches) {
                  return (
                    <Row className="mb-2">
                      <Col sm="8">
                        <Row>
                          <Col>
                            <InputGroup>
                              <Input
                                type="text"
                                id="input1-group2"
                                name="input1-group2"
                                placeholder="Buscar"
                                value={this.state.filter}
                                onChange={(e) =>
                                  this.setState({ filter: e.target.value })
                                }
                                onKeyPress={this.handleInputFilterChange}
                              />
                              <div className="input-group-prepend">
                                <Button
                                  type="button"
                                  color="primary"
                                  onClick={() => this.filterQuotations()}
                                >
                                  <i className="fa fa-search"></i>
                                </Button>
                              </div>
                            </InputGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm="4">
                        <ExportCSV
                          exportCSV={this.handleObtainQuotationsExport}
                        />
                      </Col>
                    </Row>
                  );
                } else {
                  return (
                    <Row className="mb-2">
                      <Col md="5">
                        <Row>
                          <Col>
                            <InputGroup>
                              <Input
                                type="text"
                                id="input1-group2"
                                name="input1-group2"
                                placeholder="Buscar"
                                value={this.state.filter}
                                onChange={(e) =>
                                  this.setState({ filter: e.target.value })
                                }
                                onKeyPress={this.handleInputFilterChange}
                              />
                              <div className="input-group-prepend">
                                <Button
                                  type="button"
                                  color="primary"
                                  onClick={() => this.filterQuotations()}
                                >
                                  <i className="fa fa-search"></i>
                                </Button>
                              </div>
                            </InputGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="2">
                        <ExportCSV
                          exportCSV={this.handleObtainQuotationsExport}
                        />
                      </Col>
                    </Row>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />

            <Row className="mb-2">
              <Col>
                <div className="float-right">
                  <Button
                    color="primary"
                    onClick={() =>
                      this.props.history.push("/administration/quotations/add")
                    }
                  >
                    <i className="fa fa-plus mr-1"></i> Nuevo
                  </Button>
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(columnsXS)}
                </MediaQuery>
                <MediaQuery
                  minWidth={layout.SM_MIN_WIDTH}
                  maxWidth={layout.MD_MAX_WIDTH}
                >
                  {this.renderDataTable(columnsSM)}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                  {this.renderDataTable(columns)}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { quotations, error, loading, pageSize, total } =
    state.quotation.quotationsList;

  return {
    quotations,
    error,
    loading,
    pageSize,
    total,

    role: selectUserRole(state),

    deletedQuotation: state.quotation.deleteQuotation.quotation,
    deleteError: state.quotation.deleteQuotation.error,
    deleteLoading: state.quotation.deleteQuotation.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getQuotations,
      deleteQuotation,
      resetQuotations,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(QuotationList);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationList/QuotationList.js